import Component from './TikTokAnalyticsPublicTrafficSource.vue'
export default Component
